// 1 : 'SITE_OWNER'
// 2 : 'NORMAL_USER', 'SITE_OWNER'
export function NavItem(title, icon, href, accessibleFor, templates) {
  this.title = title || '';
  this.icon = icon || '';
  this.href = href || '/';
  this.accessibleFor = accessibleFor || '/';
  this.templates = templates || [];
}
